export default __webpack_public_path__ + "static/Klasse_Steira_MU-3a7e61916494dce9c69e967de82dfab1.jpg";